import React from 'react';
import { ICustomBarLabel, ICustomBarLabelPosition } from './types';

interface IProps {
  label: ICustomBarLabel & ICustomBarLabelPosition;
  opacity?: number | string;
}

/**
 * Shows a translucent mask around the label to visualize and debug
 * any wrong position of labels visually
 */
const debugLabel = false;

const DebugMask = ({ label }: IProps) => (
  <rect
    x={label.bar.x}
    y={label.position.y0}
    width={label.bar.width}
    height={label.position.y1 - label.position.y0}
    fill="red"
    stroke="#000"
    opacity={0.1}
  />
);

export const CustomBarLabel = ({ label, opacity = 1 }: IProps) => {
  if (label.bar.height < 0) {
    // bar height becomes negative when the bar is below the min value
    // of the custom Y-Axis min value
    return null;
  }
  // works due to textAnchor="middle"
  const centerX = label.bar.x + label.bar.width / 2;
  return (
    <>
      {debugLabel && <DebugMask label={label} />}
      <text
        x={centerX}
        y={label.position.y1}
        fill={label.insideBar ? label.insideBarColor : label.outsideBarColor}
        textAnchor="middle"
        fontFamily="Geist"
        {...(label.svgProps ?? {})}
        opacity={opacity}
        style={{ pointerEvents: 'none' }}
      >
        {label.value}
      </text>
    </>
  );
};
